
import React from "react";
import { Grid, MenuItem, styled, TextField, Typography } from "@mui/material";
import { Controller, Control, FieldValues, FieldPath } from "react-hook-form";


const InputWrapperGrid = styled(Grid)(() => ({
    padding: "1%",
}));

const TitleGrid = styled(Grid)({
    paddingLeft: "10%",
});

const FullTextField = styled(TextField)({
    width: "80%",
});


export type SelectOption = {
    value: string | number;
    text: string;
};

type FormSelectInputProps<T extends FieldValues> = {
    name: FieldPath<T>;
    control: Control<T>;
    title: string;
    options: SelectOption[];
    placeholder?: string;
};

export default function FormSelectInput<T extends FieldValues>({
    name,
    control,
    title,
    options,
    placeholder = "-- Please choose an option --", // Default placeholder
}: FormSelectInputProps<T>) {
    return (
        <InputWrapperGrid container justifyContent="center">
            <TitleGrid item xs={12}>
                <Typography variant="h6" color="black">
                    {title}
                </Typography>
            </TitleGrid>
            <Grid container justifyContent="center" item xs={12}>
                <Controller
                    name={name}
                    control={control}
                    render={({ field, fieldState: { error } }) => (
                        <FullTextField
                            {...field}
                            select
                            variant="outlined"
                            error={!!error}
                            helperText={error?.message || ""}
                        >
                            <MenuItem value="" disabled>
                                {placeholder}
                            </MenuItem>
                            {options.map((option) => (
                                <MenuItem key={option.value} value={String(option.value)}>
                                    {option.text}
                                </MenuItem>
                            ))}
                        </FullTextField>
                    )}
                />
            </Grid>
        </InputWrapperGrid>
    );
}